import React from "react";
import CartItems from "../Components/Cart/CartItems";

const Cart = () => {
  return (
    <>
      <CartItems />
    </>
  );
};

export default Cart;
